import { useTheme } from "../../../components/hooks/useTheme";

type DetailsTagProps = {
    title: string;
    value: string;
    bg?: string;
}

const DetailsTag = ({ title, value, bg }: DetailsTagProps) => {
  const { themeStyles, theme } = useTheme();

  const textColor =
  theme === "dark"
    ? `${themeStyles.main.textSubHeadingColor}`
    : `${themeStyles.main.textHeadingColor}`;

    return (
        <div style={{ flex: bg ? "unset" : "1" }}>
        <h5 className={`font-medium pt-1 ${textColor}`}>
          {title}
          </h5>
        <p
         className={`text-sm ${bg ? "bg-transparent text-white" : textColor}`}
         style={{
           backgroundColor: bg || "transparent",
           padding: bg ? "0.125rem 0.5rem" : "0 0",
           width: bg ? "fit-content" : "auto",
           borderRadius: bg ? "0.25rem" : "0",
           fontWeight: bg ? 500 : 400,
         }} 
        >
          {value}
        </p>
      </div>
      
    )
}

export default DetailsTag